import script from "./PageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=e3acb36c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3acb36c"]])

export default __exports__